import PropTypes from 'prop-types';
import { twJoin } from 'tailwind-merge';

import Tag from 'shopper/components/Tag/V2';

import OFFER from 'constants/offer';

const TAGS_BY_VISIBILITY = {
  [OFFER.VISIBILITY_STATUS.APP_ONLY]: OFFER.BADGES.APP_ONLY,
  [OFFER.VISIBILITY_STATUS.LOGGED_ONLY]: OFFER.BADGES.EXCLUSIVE,
};

const OfferTag = ({ className, offerUserVisibility, offerTags }) => {
  if (TAGS_BY_VISIBILITY[offerUserVisibility]) {
    return (
      <Tag
        className={twJoin('whitespace-pre', className)}
        size="size3"
        type="secondary"
        filled
      >
        {TAGS_BY_VISIBILITY[offerUserVisibility]}
      </Tag>
    );
  }

  return (
    <Tag className={twJoin('whitespace-pre', className)} size="size3" filled>
      {offerTags[0]?.name}
    </Tag>
  );
};

OfferTag.propTypes = {
  className: PropTypes.string,
  offerUserVisibility: PropTypes.string.isRequired,
  offerTags: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      type: PropTypes.string.isRequired,
    })
  ),
};

export default OfferTag;
